module.exports = __webpack_public_path__ + "img/creditcard.dcba41d1.png";